import React from 'react';
import PageHero from '../components/layout/PageHero';
import EvPerformanceRangeSimulator from '../components/tools/EvPerformanceRangeSimulator';
import { ToolGuideCta } from '../components/layout/GuideLayout';

const EvPerformanceRangeSimulatorPage = () => {
  return (
    <div className="min-h-screen" data-testid="ev-performance-range-simulator-page">
      <PageHero
        eyebrow="Engineering Utilities"
        title="EV Powertrain Simulator"
        description="Enter your vehicle and battery parameters, then submit to size the motor (continuous, 30-min, and peak duty ratings) and battery pack, and see the full performance and energy simulation."
        testId="ev-performance-range-simulator-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <EvPerformanceRangeSimulator />
          <ToolGuideCta guidePath="/simulation/ev-powertrain/guide" toolName="EV Powertrain Simulator" />
        </div>
      </section>
    </div>
  );
};

export default EvPerformanceRangeSimulatorPage;
